import React, { useMemo, useState } from "react";

const Badge = ({ type, children }) => (
  <span className={`badge ${type === "income" ? "badge-income" : "badge-expense"}`}>{children}</span>
);

const TransactionList = ({ transactions, onDelete }) => {
  const [filter, setFilter] = useState("all");
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    return transactions.filter(t => {
      const okType = filter === "all" ? true : t.type === filter;
      const okQuery = query.trim()
        ? ((t.title || "").toLowerCase().includes(query.toLowerCase()) || (t.category || "").toLowerCase().includes(query.toLowerCase()))
        : true;
      return okType && okQuery;
    });
  }, [transactions, filter, query]);

  return (
    <div className="card list-card">
      <div className="card-header list-header">
        <h3>Recent Transactions</h3>
        <div className="filters">
          <input type="text" placeholder="Search title/category..." value={query} onChange={e => setQuery(e.target.value)} />
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">All</option>
            <option value="income">Income</option>
            <option value="expense">Expense</option>
          </select>
        </div>
      </div>

      <ul className="transaction-list">
        {filtered.map(t => (
          <li key={t.id} className="transaction-item">
            <div className="ti-left">
              <div className="ti-title">{t.title || t.description || t.category}</div>
              <div className="ti-meta">
                <Badge type={t.type}>{t.type}</Badge>
                <span className="dot">•</span>
                <span className="ti-cat">{t.category}</span>
                <span className="dot">•</span>
                <span className="ti-date">{new Date(t.date).toLocaleDateString()}</span>
              </div>
            </div>
            <div className={`ti-amount ${t.type === "income" ? "pos" : "neg"}`}>
              {t.type === "income" ? "+" : "-"}₹{t.amount.toLocaleString(undefined, { maximumFractionDigits: 2 })}
            </div>
            <button className="ti-delete" onClick={() => onDelete(t.id)} title="Delete">✕</button>
          </li>
        ))}
        {filtered.length === 0 && <li className="empty">No transactions found</li>}
      </ul>
    </div>
  );
};

export default TransactionList;
